/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  getEventTemplate,
  resetEventTemplate,
} from '@pingum/app-state-management/eventTemplate/actions';

import {
  Modal,
  useMediaQuery,
} from '@mui/material';
import Page from '../../../components/Page';
import PageBody from '../../../components/PageBody';
import { getQueryParam } from '../../../utils/urlHelper';
import EventTemplateEditor from './components/EventTemplateEditor';
import theme from '../../../utils/theme';

const TaskDetailSettingsPage = ({
  navigate,
  unreadCount,
  chatClient,
  modal,
  openModal,
  passedInModalId,
  onCloseModal,
}) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();

  const id = getQueryParam('copy') || passedInModalId || window.location.pathname.replace(/^\/settings\/tasks[/]?/, '').replace(/\/{0,1}\?.*/g, '');

  // Redux state
  const {
    isFetchingEventTemplate,
    eventTemplate: selectedEventTemplate,
  } = useSelector((state) => state.eventTemplate);
  const { isFetchingStatuses } = useSelector((state) => state.status);
  const { isFetchingTag } = useSelector((state) => state.tag);
  const { isFetchingTagTypes } = useSelector((state) => state.tagType);

  const isLoading = isFetchingEventTemplate || isFetchingStatuses || isFetchingTag || isFetchingTagTypes;
  const isCopy = !!getQueryParam('copy');

  React.useEffect(() => {
    const checkId = getQueryParam('copy') || passedInModalId || window.location.pathname.replace(/^\/settings\/tasks[/]?/, '').replace(/\/{0,1}\?.*/g, '');
    if (checkId && checkId !== 'new') {
      dispatch(getEventTemplate(checkId));
    } else {
      dispatch(resetEventTemplate());
    }
  }, [passedInModalId, id]);

  const getEventTemplateEditor = () => (
    <EventTemplateEditor
      navigate={navigate}
      isLoading={isLoading}
      eventTemplate={!id
        ? ({
          name: '',
          description: '',
          eventData: [],
          tags: [],
          allowActiveDuplicates: true,
          eventDataDefaultValues: {},
          workflowStatuses: [],
          configurableTags: true,
          configurableName: true,
          configurableStartStatus: true,
          defaultStartStatus: {
            id: 0,
            name: 'Select A Value...',
            icon: 'search',
            iconColor: 'gray',
          },
        })
        : ((id && isCopy)
          ? {
            ...selectedEventTemplate,
            id: null,
          }
          : selectedEventTemplate)}
      onClose={onCloseModal}
      modal={openModal && modal}
    />
  )

  if (modal) {
    return (
      <Modal
        open={openModal}
        onClose={onCloseModal}
        aria-labelledby="modal-add-feed-title"
        aria-describedby="modal-add-feed-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'rgb(244, 244, 244)',
            borderRadius: 1,
            p: 2,
            overflow: 'auto',
            maxHeight: fullScreen
              ? '100%'
              : '90%',
            width: fullScreen
              ? '100%'
              : '90%',
          }}
        >
          {getEventTemplateEditor()}
        </Box>
      </Modal>
    )
  }

  if (!id) {
    return (
      <Page>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
          }}
        >
          <PageBody navigate={navigate} chatClient={chatClient} unreadCount={unreadCount}>
            {getEventTemplateEditor()}
          </PageBody>
        </Box>
      </Page>
    );
  }

  return (
    <Page>
      <Box sx={{ width: '100%' }}>
        <PageBody navigate={navigate} chatClient={chatClient} unreadCount={unreadCount}>
          {getEventTemplateEditor()}
        </PageBody>
      </Box>
    </Page>
  );
};

TaskDetailSettingsPage.propTypes = {
  navigate: PropTypes.func.isRequired,
  chatClient: PropTypes.any,
  unreadCount: PropTypes.number,
  modal: PropTypes.bool,
  openModal: PropTypes.bool,
  passedInModalId: PropTypes.any,
  onCloseModal: PropTypes.func,
};

TaskDetailSettingsPage.defaultProps = {
  chatClient: null,
  unreadCount: 0,
  modal: false,
  openModal: false,
  passedInModalId: null,
  onCloseModal: () => { },
};

export default TaskDetailSettingsPage;
